function bindMobileSubnav() {
  const pdpSubNav = document.querySelector(".pdp-subnav");
  const header = document.querySelector('header');
  const headerHeight = header.getBoundingClientRect().height;
  pdpSubNav.style.top = `${headerHeight}px`;
}

if (window.innerWidth < 750) {
  setTimeout(() => {
    bindMobileSubnav();
  }, 100)
}

function getHeaderOffset() {
  let headerOffset = 0;
  const offset = 10;
  if (window.innerWidth < 750) {
    headerOffset = document.querySelector('header').getBoundingClientRect().height + offset;
  } else {
    const subNav = document.querySelector(".pdp-subnav");
    const mainNav = document.querySelector('.main_nav');
    if (subNav) {
      headerOffset = subNav.getBoundingClientRect().height + mainNav.getBoundingClientRect().height + offset;
    }
  }

  return headerOffset;
}

function activeLink(name) {
  const links = document.querySelectorAll('.pdp-subnav__link');
  links.forEach(link => link.classList.remove("active"));

  const targetElement = document.querySelector(`[data-section="${name}"]`);
  if (targetElement) {
    targetElement.classList.add("active");
  }
}

document.addEventListener("scroll", function(e) {
  const pdpSubNav = document.querySelector(".pdp-subnav");

  if (window.innerWidth < 750) {
    setTimeout(() => {
      bindMobileSubnav();
    }, 300)
  } else {
    if (window.scrollY < 700) {
      pdpSubNav.style.top = "0";
    } else {
      const stickyHeader = document.querySelector(".main_nav_wrapper.sticky_nav");
      if (stickyHeader) {
        const stickyHeaderHeight = Math.floor(stickyHeader.getBoundingClientRect().height);
        pdpSubNav.style.top = `${stickyHeaderHeight}px`;
      }
    }
  }

  // Set active tab automatically
  const headerOffset = getHeaderOffset() + 10;

  const featuresBlock = document.querySelector('.fifty-fifty');
  const featuredSections = document.querySelectorAll('.featured-link--section');
  // const reviewBlock = document.querySelector('.review');  
  const specBlock = featuredSections[featuredSections.length - 1];
  const supportBlock = document.querySelector('.support');

  if (supportBlock.getBoundingClientRect().top < headerOffset) {
    activeLink("support");
  } else if (specBlock.getBoundingClientRect().top < headerOffset) {
    activeLink("specs");
  // } else if (reviewBlock.getBoundingClientRect().top < headerOffset) {
  //   activeLink("review");
  } else if (featuresBlock.getBoundingClientRect().top < headerOffset) {
    activeLink("features");
  } else {
    activeLink("product");
  }

  // Check if scroll is out of app content
  const app = document.getElementById("app");
  if (window.scrollY + headerOffset > app.getBoundingClientRect().height) {
    pdpSubNav.classList.add("pdp-subnav--fixed");
  } else {
    pdpSubNav.classList.remove("pdp-subnav--fixed");
  }
});

const subLinks = document.querySelectorAll(".pdp-subnav__link");
subLinks.forEach(function(sublink) {
  sublink.addEventListener("click", function(event) {
    event.preventDefault();

    const section = event.target.dataset.section;
    let element = document.querySelector(".main.content");
    if (section == "features") {
      element = document.querySelector(".fifty-fifty");
    } else if (section == "specs") {
      const featuredSections = document.querySelectorAll('.featured-link--section')
      element = featuredSections[featuredSections.length - 1];
    // } else if (section == "review") {
    //   element = document.querySelector(".review");
    } else if (section == "support") {
      element = document.querySelector(".support");
    } 

    const headerOffset = getHeaderOffset();   

    const bodyRect = document.body.getBoundingClientRect().top;
    const elementPosition = element.getBoundingClientRect().top - bodyRect;
    const offsetPosition = section == "product" ? 0 : elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    })
  });
});